import { ADD_JOB_ROLE_EXPANDER } from '@aibees/elephant/constants';
import { HttpMethod } from '@aibees/shared/definition';
import { useBaseMutation } from '@aibees/shared/http';
import { useWorkspace } from '@aibees/shared/workspace';
import {
  AddJobRoleExpanderRequest,
  AddJobRoleExpanderResponse,
} from '../types';

export function useAddJobRoleExpanderMutation() {
  const wid = useWorkspace()?.id;

  return useBaseMutation<AddJobRoleExpanderRequest, AddJobRoleExpanderResponse>(
    {
      url: ADD_JOB_ROLE_EXPANDER.replace(':wid', String(wid)),
      method: HttpMethod.post,
    }
  );
}
